import React, { useRef, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import { useForm, Controller } from 'react-hook-form'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import FlexView from 'react-flexview/lib'
import NewFillButton from '../Core/NewFillButton'
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { MenuItem, Button, makeStyles, InputAdornment, IconButton, Avatar } from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'

export const ManageOdometerUploadPopup = ({ open, title, body, onConfirm, onCancel, ...props }) => {
  const {
    register,
    errors,
    getValues,
    setValue,
    triggerValidation,

    control,
  } = useForm()

  const useStylesButton = makeStyles(theme => ({
    root: {
      backgroundColor: '#c7cbcf',
      '&:hover': {
        backgroundColor: '#b1b6bb',
      },
    },
  }))

  const classes = useStylesButton()

  const handleClose = () => {
    onCancel && onCancel()
  }
  const myPoliciesContext = React.useContext(PolicyManagementContextStore)

  const vehiclesWithPendingOdodmeters = myPoliciesContext.all_policies
    .map(p =>
      p.insuredVehicles.map(iv => ({
        insuranceId: p.insuranceId,
        have_open_odometer_request: iv.have_open_odometer_request,
        id: iv.id,
        year: iv.year,
        make: iv.make,
        model: iv.model,
        vin: iv.vin,
      }))
    )
    .flat()
    .sort((a, b) => (a.have_open_odometer_request > b.have_open_odometer_request ? 1 : -1))

  const imageInputField = useRef(null)
  const [previewImage, setImg] = useState('')
  const [imgName, setImgName] = useState('')

  const imageField = getValues('image')

  if (!imageField) {
    register('image', {
      validate: {
        required: f => !(f && Object.keys(f).length),
      },
    })
    setValue('image', {})
  }

  const onPictureSelected = async event => {
    setImg(URL.createObjectURL(event.target.files[0]))
    setImgName(event.target.files[0].name)
    setValue('image', event.target.files[0])
  }

  const Confirm = async () => {
    let valid = await triggerValidation()
    if (!valid) return
    //handleClose()
    const values = getValues()
    const motorcycleDetails = vehiclesWithPendingOdodmeters.filter(o => o.id === values.motorcycleId)[0]
    onConfirm && onConfirm(motorcycleDetails.insuranceId, values)
  }

  return (
    <SkywatchDialog
      open={open}
      closeDialog={handleClose}
      maxWidth={'xs'}
      circleHeader={
        <ElevatedCircle>
          {' '}
          <AlternateEmailIcon className="blue" />{' '}
        </ElevatedCircle>
      }
      closeTitle={title}
    >
      <FlexView column>
        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">{title}</div>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FlexView className="margin-top-basic">
              <TextField
                disabled
                onClick={() => imageInputField.current.click()}
                fullWidth
                variant="outlined"
                label="Upload Image"
                error={!!errors.image}
                helperText={!!errors.image && 'odometer image is required'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {!previewImage ? (
                        <Button className={classes.root} variant="contained" color="primary" aria-label="upload-image">
                          <CloudUploadIcon className="white" />
                        </Button>
                      ) : (
                        <IconButton>
                          <Avatar aria-label="image-avatar" src={previewImage} />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                inputRef={register}
                value={imgName}
              />
            </FlexView>
            <input type="file" accept="image/*" id="file" onChange={onPictureSelected} ref={imageInputField} style={{ display: 'none' }} />
          </Grid>
          <Grid item xs={12}>
            <div className="textcenter margin-bottom-basic">
              <Controller
                rules={{
                  validate: field => field && field != 'none',
                }}
                name="motorcycleId"
                defaultValue={'none'}
                control={control}
                error={!!errors.motorcycleId}
                helperText={!!errors.motorcycleId && 'motorcycle is required'}
                as={
                  <TextField fullWidth select variant="outlined">
                    <MenuItem disabled value={'none'}>
                      Choose Motorcycle
                    </MenuItem>
                    {vehiclesWithPendingOdodmeters.map(iv => (
                      <MenuItem disabled={!iv.have_open_odometer_request} value={iv.id}>
                        {iv.year} {iv.make} {iv.model} {iv.vin}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
            </div>
          </Grid>
        </Grid>

        <NewFillButton onClick={Confirm}>OK</NewFillButton>
        <div onClick={handleClose} className="margin-bottom-basic text-body textcenter gray underline clickable">
          Close
        </div>
      </FlexView>
    </SkywatchDialog>
  )
}
